jQuery(function ($) {


    $('.main-nav').on(
        'show.zf.dropdownmenu', function() {
        var dropdown = $(this).find('.is-dropdown-submenu');
        dropdown.css('display', 'none');
        dropdown.fadeIn(400);
    });
    $('.main-nav').on(
        'hide.zf.dropdownmenu', function() {
        var dropdown = $(this).find('.is-dropdown-submenu');
        dropdown.css('display', 'inherit');
        dropdown.fadeOut(400);
    });

    var currentScroll = $(window).scrollTop();

    function changeOnScroll() { // Changes classes on scroll

        //console.log(window.pageYOffset);
        currentScroll = $(window).scrollTop(); 
        if (currentScroll >= 35) {
            $("#top-bar-menu").addClass("scrolled");
        }
        if (currentScroll < 35) {
            $("#top-bar-menu").removeClass("scrolled");
        }
    }

    changeOnScroll();

    $(window).scroll(function() { 
        if ($(window).width() > 640) {                 
            changeOnScroll();
        }
    });

    function widthCheck(val) { // executes code only if width range changes
        if (val == "med" && oldval == "mobile") { 
            $("html, body").animate({scrollTop: 0}, 500);
        }
        if (val != oldval) {
            oldval = val;
            //setArticleHt();
            //getTopVal();
            changeOnScroll();
        }
    }

    if ($(window).width() > 640) {
        //setArticleHt();
        widthval = "med";
        oldval = "med";
    }
    if ($(window).width() < 640) { /////// width range value is the same on load (for widthCheck)
        widthval = "mobile";
        oldval = "mobile";
    } else if ($(window).width() > 1200) {
        widthval = "xlarge";
        oldval = "xlarge";
    } else if ($(window).width() > 1024) {
        widthval = "large";
        oldval = "large";
    } else if ($(window).width() > 915) {
        widthval = "lg-med";
        oldval = "lg-med";
    } else if ($(window).width() > 800) {
        widthval = "med-lg";
        oldval = "med-lg";
    } 

});